import { replaceAll, lpad } from "./utilitarioString";
import padStart from "lodash/padStart";

import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc' 
import timezone from 'dayjs/plugin/timezone' 
import customParseFormat from 'dayjs/plugin/customParseFormat' 

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

export const formatarNit = (nit) => {
  nit = nit.toString();

  // Formato SAT: 110.15177.32-2
  var nitFormatado = nit.slice(-1);
  nitFormatado = nit.slice(-3, -1) + "-" + nitFormatado;
  nitFormatado = nit.slice(-8, -3) + "." + nitFormatado;
  nitFormatado = nit.slice(-11, -8) + "." + nitFormatado;

  return nitFormatado;
};

export const encodeUrlNb = (nb) => {
  if (!nb) return;
  nb = nb.toString();
  nb = replaceAll(nb, "-", "");
  nb = replaceAll(nb, ".", "");
  return nb;
};

export const formatarCnpj = (cnpj) => {
  if (!cnpj || cnpj === undefined) return "";

  cnpj = cnpj.toString();

  if (cnpj.length > 8) {
    const cnpjComZeros = padStart(cnpj, 14, "0");
    return cnpjComZeros.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      "$1.$2.$3/$4-$5"
    );
  } else {
    const cnpjComZeros = padStart(cnpj, 8, "0");
    return cnpjComZeros.replace(/^(\d{2})(\d{3})(\d{3})/, "$1.$2.$3");
  }
};

export const formatarDataDiaMesAno = (data) => {
  var datas = data;
  data = datas.toString();

  var dataFormatada =
    data.substring(8, 10) +
    "/" +
    data.substring(5, 7) +
    "/" +
    data.substring(0, 4);
  return dataFormatada;
};

export const formatarCpf = (cpf) => {
  if (cpf === undefined) return "";

  cpf = lpad(cpf.toString(), "0", 14);

  // Ex: 11122233300
  let cpfFormatado = cpf.slice(-2);
  cpfFormatado = cpf.slice(-5, -2) + "-" + cpfFormatado;
  cpfFormatado = cpf.slice(-8, -5) + "." + cpfFormatado;
  cpfFormatado = cpf.slice(-11, -8) + "." + cpfFormatado;

  return cpfFormatado;
};

export const formatarNB = (nb) => {
  if (nb === null || nb === undefined || nb === "") return "";

  nb = nb.toString();
  nb = replaceAll(nb, ".", "");
  nb = replaceAll(nb, ",", "");
  nb = replaceAll(nb, "-", "");
  nb = lpad(nb, "0", 10);

  let nbFormatado = nb.slice(-1);
  nbFormatado = nb.slice(-4, -1) + "-" + nbFormatado;
  nbFormatado = nb.slice(-7, -4) + "." + nbFormatado;
  nbFormatado = nb.slice(-10, -7) + "." + nbFormatado;

  return nbFormatado;
};

export const formatarDataHora = (date) => {
  return dayjs(date).tz("America/Sao_Paulo").format("DD/MM/YYYY HH:mm:ss");
};

export const formatarDataHoraMinuto = (date) => {
  return dayjs(date).tz("America/Sao_Paulo").format("DD/MM/YYYY HH:mm");
}

export const formatarDataHoraMinutoComSeparador = (date) => {
  return dayjs(date).tz("America/Sao_Paulo").format("DD/MM/YYYY - HH:mm");
}

export const formatToBrDate = (date) => {
  return dayjs.utc(date).format("DD/MM/YYYY");
};

export const formatarMoeda = (num, exibirSimbolo = true, simbolo = "R$") => {
  if (typeof num == "number") num = num.toString();
  if (num !== null && num !== undefined && num.trim() !== "") {
    var var1 = num.replace(",", ".");
    var var2 = parseFloat(var1);
    var var3 = var2.toFixed(2);
    var valorFormatado = var3
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    if (exibirSimbolo) {
      simbolo = simbolo ? simbolo : "R$";
      return simbolo + " " + valorFormatado;
    } else {
      return valorFormatado;
    }
  } else {
    return num;
  }
};

export const isoDateStringToDate = (isoDate) => {
  return isoDate ? new Date(isoDate.split("T")[0].replace(/-/g, "/")) : null;
};

export const formatInputDate = (isoDate) => {
  if (!isoDate) return isoDate;
  let date = isoDateStringToDate(isoDate);

  let day =
    date.getUTCDate() > 9
      ? date.getUTCDate().toString()
      : "0" + date.getUTCDate().toString();
  let month =
    date.getMonth() + 1 > 9
      ? (date.getMonth() + 1).toString()
      : "0" + (date.getMonth() + 1).toString();
  let year = date.getFullYear();

  return year + "-" + month + "-" + day;
};

export const formatDate = (date, formatFrom, formatTo) => {
  if (!date) return "";

  if (typeof date === 'number') {
    return dayjs(date.toString(), formatFrom).format(formatTo);
  }

  return dayjs(date, formatFrom).format(formatTo);
};

export const formatarCei = (cei) => {
  if (cei === undefined) return "";

  return String(cei)
    .replace(/\D/g, "")
    .padStart(12, "0")
    .replace(/^(\d{2})(\d{3})(\d{5})(\d{2})/, "$1.$2.$3/$4");
};

export const formatarTelefone = (telefone) => {
  if (!telefone) return "";

  return String(telefone)
    .replace(/\D/g, "")
    .padStart(10, " ")
    .replace(/^(.{2})(\d{5})(\d{4})$/, "($1) $2-$3")
    .replace(/^(.{2})(\d{4})(\d{4})$/, "($1) $2-$3");
};